module.exports = __webpack_public_path__ + "static/image/history/pc/201702.jpg?f08e06e5";